const TOURS_RESERVATIONS = {
  //getPaymentInfo
  TOURS_RESERVATIONS_PAYMENTS_INFO: 'TOURS_RESERVATIONS_PAYMENTS_INFO',
  //getReservationPayments
  TOURS_RESERVATIONS_PAYMENTS: 'TOURS_RESERVATIONS_PAYMENTS',
  //getPaymentMethodsTypes
  TOURS_PAYMENT_METHOD_TYPES: 'TOURS_PAYMENT_METHOD_TYPES',
  //getReservationServices
  TOURS_RESERVATION_SERVICES: 'TOURS_RESERVATION_SERVICES',
  //getCalculationStatusTypes
  TOURS_CALCULATION_STATUS_TYPE: 'TOURS_CALCULATION_STATUS_TYPE',
  //getReservationType
  TOURS_RESERVATION_TYPE: 'TOURS_RESERVATION_TYPE',
  //getOccupancyPartners
  TOURS_OCCUPANCY_PARTNERS: 'TOURS_OCCUPANCY_PARTNERS',
};

export default TOURS_RESERVATIONS;
